import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import Page from '../layout/components/Page';

const CoInvestmentsPage = () => {
  const { pathname } = useLocation<{ pathname: string }>();
  const makeActive = (path: string) => {
    const splitLocation = pathname.split('/');

    console.log(splitLocation);

    if (splitLocation[2]) {
      return splitLocation[2] === path ? 'active' : 'false';
    }
    return '';
  };
  return (
    <Page title='Co Investments'>
      <div className='card'>
        <div className='card-body'>
          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('received'))} to='/co-investments/received'>
                  Request Received
                </Link>
              </li>
              <li className='nav-item'>
                <Link className={clsx('nav-link text-active-primary me-6', makeActive('sent'))} to='/co-investments/sent'>
                  Request Sent
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default CoInvestmentsPage;
